module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_p7"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("By ")]), _c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("M")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("ARY")]), _c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v(" C")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("ALMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p8"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "text-decoration": "underline !important"
    }
  }, [_vm._v("N")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em",
      "text-decoration": "underline !important"
    }
  }, [_vm._v("OVELS")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("C")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em"
    }
  }, [_vm._v("HANGE")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "0.58em"
    }
  }, [_vm._v("OF")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v(" H")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em"
    }
  }, [_vm._v("EART")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v(" S")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em"
    }
  }, [_vm._v("ERIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Change of Heart • Trusted Bond • Honored Vow")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p8"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Crucible of Fate")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("A Matter of Time Vol. 1 & 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Bulletproof • But For You")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p8"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Parting Shot")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Acrobat")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("The Guardian")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Mine")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Three Fates (anthology)")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Timing")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Warders Vol. 1 & 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p9"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "text-decoration": "underline !important"
    }
  }, [_vm._v("N")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em",
      "text-decoration": "underline !important"
    }
  }, [_vm._v("OVELLAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("After the Sunset")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Again")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Any Closer")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Frog")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Romanus")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("The Servant")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Steamroller")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Still")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p8"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("What Can Be")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("T")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em"
    }
  }, [_vm._v("HE")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v(" W")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em"
    }
  }, [_vm._v("ARDER")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v(" S")]), _c('span', {
    staticStyle: {
      "font-size": "0.58em"
    }
  }, [_vm._v("ERIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("His Hearth • Tooth & Nail • Heart in Hand")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("Sinnerman • Nexus • Cherish Your Name")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p9"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("Published by D")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("REAMSPINNER")]), _c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v(" P")]), _c('span', {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("RESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_p0"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0